<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <p>
        Excellent!  ChatAcuity has started joining the selected channels.
      </p>

      <p>
        Would you like ChatAcuity to join new channels automatically as they are created?  This ensures that any activity in public channels created after this installation is captured and analyzed without having to explicitly invite the app.
      </p> 

      <b-alert class="mt-3"  show fade>
        <b-form-checkbox
          id="autoJoinCheckbox"
          v-model="autoJoinChecked"
          name="autoJoinCheckbox"
          value="checked"
          unchecked-value="unchecked"
        >Auto-join new public channels</b-form-checkbox>
      </b-alert>


      <p>
        Click 'Next' to continue
      </p>

    </b-card-text>

    <b-button :disabled="submittedAutoJoinRequest" class="float-right" href="#" variant="primary" @click="nextButtonClick">Next</b-button>
  </div>
</template>


<script>
export default {
  name: 'Step2Part3',
  data: function() {
    return {
      autoJoinChecked: 'unchecked',
      submittedAutoJoinRequest: false
    }
  },

  methods: {
    nextButtonClick() {
      if(this.autoJoinChecked == 'checked') {
        this.$store.dispatch('setAutoJoinNewChannels', true)  // autojoin true
        this.submittedAutoJoinRequest = true
      } else {
        this.$store.commit('installStep', 3)
        this.$router.push({ name: 'step3' })
      }
      
    }
  },

  mounted() {
    this.$store.commit('installProgress', 65)
  }
}
</script>